import * as yup from 'yup';
import useTranslation from '../../../Hooks/useTranslation';
import { NCZIReferenceValidator } from '../../Nczi/Components/ReferenceSearchSelect/NCZIReferenceSearchSelect';

export default function usePatientManualRegistrationSlovakiaFormValidationScheme() {
	const { t } = useTranslation();

	const getValidationScheme = ({
		isChild,
		isGenderRequested,
		isBirthDateRequested,
	}: {
		isChild?: boolean;
		isGenderRequested?: boolean;
		isBirthDateRequested?: boolean;
	}) => {
		return yup.object({
			insuranceNumber: yup.string().when('ignoreInsuranceNumberCheck', {
				is: true,
				then: yup.string().notRequired().nullable(),
				otherwise: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.insuranceNumber'),
					),
			}),
			ignoreInsuranceNumberCheck: yup.boolean().notRequired().nullable(),
			salutationBefore: yup.string().notRequired().nullable(),
			salutationAfter: yup.string().notRequired().nullable(),
			firstName: yup
				.string()
				.required(t('validation.patientManualRegistrationCzechForm.firstName')),
			lastName: yup
				.string()
				.required(t('validation.patientManualRegistrationCzechForm.lastName')),
			address: yup.object().shape({
				street: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.street'),
					),
				descriptiveNumber: yup
					.string()
					.required(
						t(
							'validation.patientManualRegistrationCzechForm.address.descriptiveNumber',
						),
					),
				guideNumber: yup.string().notRequired().nullable(),
				city: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.city'),
					),
				postCode: yup
					.string()
					.required(
						t('validation.patientManualRegistrationCzechForm.address.postCode'),
					),
			}),
			healthInsuranceCompany: yup.mixed().notRequired().nullable(),
			citizenship: yup
				.mixed()
				.required(
					t('validation.patientManualRegistrationCzechForm.citizenship'),
				),
			state: NCZIReferenceValidator(
				'validation.patientManualRegistrationSlovakiaForm.state',
			),
			gender: isGenderRequested
				? yup
						.mixed()
						.required(
							t('validation.patientManualRegistrationSlovakiaForm.gender'),
						)
				: yup.mixed().notRequired().nullable(),
			birthDate: isBirthDateRequested
				? yup
						.date()
						.required(
							t('validation.patientManualRegistrationCzechForm.birthDate'),
						)
				: yup.date().notRequired().nullable(),
			phoneNumber: yup.string().notRequired().nullable(),
			email: yup
				.string()
				.email(t('validation.patientManualRegistrationCzechForm.email'))
				.notRequired()
				.nullable(),
			healthPlanCode: yup.mixed().notRequired().nullable(),
			healthPlanWorkplaceMember: yup.mixed().notRequired().nullable(),
			legalRepresentative: isChild
				? yup.object().shape({
						firstName: yup
							.string()
							.required(
								t(
									'validation.patientManualRegistrationCzechForm.legalRepresentative.firstName',
								),
							),
						lastName: yup
							.string()
							.required(
								t(
									'validation.patientManualRegistrationCzechForm.legalRepresentative.lastName',
								),
							),
						email: yup
							.string()
							.email(t('validation.patientManualRegistrationCzechForm.email'))
							.notRequired()
							.nullable(),
						phoneNumber: yup.string().notRequired().nullable(),
				  })
				: yup.mixed().notRequired().nullable(),
		});
	};

	return { getValidationScheme };
}
